export const styles = (theme) => ({
    root: {
        display: 'flex',
        flexFlow: 'row wrap',
    },
    nextButton: {
        marginTop: '3rem',
    },
});
